import { TSendOtpReq } from "@sharedTypes/req.type";
import { TSendOtpRes } from "@sharedTypes/res.type";

import missingParametersError from "api/Error";
import axios from "axios";

export async function SendOtp(email: string, forgot = false) {
  const apiUrl = "/email/sendotp";

  const body: TSendOtpReq = {
    email,
    forgot,
  };

  for (const [key, param] of Object.entries(body)) {
    if (param === undefined) throw missingParametersError(key);
  }

  const data: TSendOtpRes = await axios
    .post(apiUrl, body)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      throw err.response.data;
    });
  return data;
}
